// 3rd party imports
import * as React from 'react';
import { action } from 'mobx';
import { inject } from 'mobx-react';

// Bernie
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

// UITK
import { UitkTab, UitkTabs, UitkTabsType } from 'uitk-react-tabs';
import { UitkSelect } from 'uitk-react-select';
import { UitkHeading } from 'uitk-react-text';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkIcon } from 'uitk-react-icons';

// Models
import { LinkAnalyticsMicroMessageContent } from 'models/analytics';

// Components
import { HotelLobSearch } from './lob/hotels/hotel-search';
import { FlightLobSearch } from './lob/flights/flight-lob-search';
import { PackageLobSearch } from './lob/package/package-search';
import { HotelLobDetails } from './lob/hotels/hotel-details';
import { LinkSettingsForm } from './common/link-settings-form';
import { CjParameters } from './common/cj-parameters';
import { PhgParameters } from './common/phg-parameters';
import { ComingSoon } from './common/coming-soon';

// utils
import {
  getProgramAnalyticsMicroMessage,
  getProductAnalyticsMicroMessage,
  getLinkAnalyticsMicroMessage,
} from '../../util/analytics';

@inject('link', 'context', 'analytics', 'programs', 'routeStore', 'userAuth', 'products', 'userAuth')
export class DeeplinkBuilder extends React.Component<any, any> {
  public constructor(props) {
    super(props);
    this.state = {
      language: 'English',
      trackingChannel: 'PHG',
      pidValue: '',
      sidValue: '',
      selectedMainMenu: 'Hotels',
      pageList: ['Hotel Search', 'Hotel Details'],
      lobList: ['Hotels', 'Flights', 'Packages'],
      selectedPage: 'Hotel Search',
      statevalue: {},
      lobForm: this.HotelLobSearch,
      camref: '',
      adRef: '',
      creativeRef: '',
      pubRef: '',
    };
    this.renderElement = this.renderElement.bind(this);
    this.onCamRefChange = this.onCamRefChange.bind(this);
    this.onAdRefChange = this.onAdRefChange.bind(this);
    this.onCreativerefChange = this.onCreativerefChange.bind(this);
    this.onPubRefChange = this.onPubRefChange.bind(this);
    this.analyticsTrackEvents = this.analyticsTrackEvents.bind(this);
    this.props.link.setChannel('PHG');
  }

  private analyticsTrackEvents = (rfrr: string, link?: LinkAnalyticsMicroMessageContent) => {
    const { analytics, programs, routeStore, products, userAuth } = this.props;

    if (typeof analytics?.trackEvent === 'function') {
      const program = programs.getProgram(routeStore.queryParams.programName);
      const product = products.getProduct(routeStore.queryParams.programName, 'deeplink');
      const activeProgram = userAuth.getActiveUserProgram(program);

      const microMessages = [
        getProgramAnalyticsMicroMessage(program, activeProgram.programStatus),
        getProductAnalyticsMicroMessage(product),
      ];

      switch (rfrr) {
        case 'affhub.product_config':
          analytics.trackEvent(rfrr, 'AffHub Product Config Presented', null, null, true, microMessages);
          break;
        case 'affhub_copy_link.selected':
          analytics.trackEvent(rfrr, 'AffHub Copy Link Selected', null, null, true, [
            ...microMessages,
            getLinkAnalyticsMicroMessage(link),
          ]);
          break;
        default:
          break;
      }
    }
  };

  public HotelLobSearch = (<HotelLobSearch link={this.props.link} analyticsTrackEvents={this.analyticsTrackEvents} />);
  public HotelLobDetails = (
    <HotelLobDetails link={this.props.link} analyticsTrackEvents={this.analyticsTrackEvents} />
  );
  public FlightLobSearch = (
    <FlightLobSearch link={this.props.link} analyticsTrackEvents={this.analyticsTrackEvents} />
  );
  public PackageLobSearch = (
    <PackageLobSearch link={this.props.link} analyticsTrackEvents={this.analyticsTrackEvents} />
  );

  public componentDidMount() {
    setTimeout(() => {
      this.analyticsTrackEvents('affhub.product_config');
    }, 3500);
  }

  public setSelectedMainMenu = (selectedMainMenu) => {
    this.setState({ selectedMainMenu });
    const hotelPages = ['Hotel Search', 'Hotel Details'];
    const flightPages = ['Flight Search'];
    const packagePages = ['Flight + Hotel'];
    const carPages = ['Car Search', 'Car Details'];
    let pagesList = [];
    this.setState({
      lobForm: '',
    });
    if (selectedMainMenu === 'Hotels') {
      pagesList = [...hotelPages];
      this.setState({
        lobForm: this.HotelLobSearch,
      });
    }
    if (selectedMainMenu === 'Flights') {
      pagesList = [...flightPages];
      this.setState({
        lobForm: this.FlightLobSearch,
      });
    }
    if (selectedMainMenu === 'Packages') {
      pagesList = [...packagePages];
      this.setState({
        lobForm: this.PackageLobSearch,
      });
    }
    if (selectedMainMenu === 'Cars') {
      pagesList = [...carPages];
    }
    this.setState({
      pageList: pagesList,
    });
  };

  public renderLobDropDown = () => {
    return this.state.lobList.map((lob) => {
      return (
        <option key={lob} value={lob}>
          {lob}
        </option>
      );
    });
  };

  public renderPageDropDown = () => {
    return this.state.pageList.map((pages) => {
      return (
        <option key={pages} value={pages}>
          {pages}
        </option>
      );
    });
  };

  @action
  public renderLobForm() {
    this.setState({
      lobForm: '',
    });
    if (this.state.selectedPage === 'Hotel Search') {
      this.setState({
        lobForm: this.HotelLobSearch,
      });
    }
    if (this.state.selectedPage === 'Hotel Details') {
      this.setState({
        lobForm: this.HotelLobDetails,
      });
    }
    if (this.state.selectedPage === 'Flight Search') {
      this.setState({
        lobForm: this.FlightLobSearch,
      });
    }
    if (this.state.selectedPage === 'Flight + Hotel') {
      this.setState({
        lobForm: this.PackageLobSearch,
      });
    }
  }

  public setSelectedMainMenuDropDown = (event) => {
    const { value } = event.target;
    this.setState({
      selectedMainMenu: value,
    });
    this.setState({ value });
    const hotelPages = ['Hotel Search', 'Hotel Details'];
    const flightPages = ['Flight Search'];
    const carPages = ['Car Search', 'Car Details'];
    let pagesList = [];
    this.setState({
      lobForm: '',
    });
    if (value === 'Hotels') {
      pagesList = [...hotelPages];
      this.setState({
        lobForm: this.HotelLobSearch,
      });
    }
    if (value === 'Flights') {
      pagesList = [...flightPages];
      this.setState({
        lobForm: this.FlightLobSearch,
      });
    }
    if (value === 'Packages') {
      this.setState({
        lobForm: this.PackageLobSearch,
      });
    }
    if (value === 'Cars') {
      pagesList = [...carPages];
    }
    this.setState(
      {
        pageList: pagesList,
      },
      () => {
        this.renderPageDropDown();
      },
    );
  };

  public handlePageMenuChange = (event) => {
    const { value } = event.target;
    this.setState(
      {
        selectedPage: value,
      },
      () => {
        this.renderLobForm();
      },
    );
  };

  public handleLanguageSelectChange = (event) => {
    const { value } = event.target;
    this.setState({
      language: value,
    });
    this.props.link.setLanguage(value);
  };

  public handleTrackingChannelSelectChange = (event) => {
    const { value } = event.target;
    this.setState({
      trackingChannel: value,
    });
    this.props.link.setChannel(value);
  };

  public handlePIDSelectChange = (event) => {
    const { value } = event.target;
    this.setState({
      pidValue: value,
    });
    this.props.link.setPid(value);
  };

  public handleSIDChange = (event) => {
    const { value } = event.target;
    this.setState({
      sidValue: value,
    });
    this.props.link.setSid(value);
  };

  public onCamRefChange(event) {
    const { value } = event.target;
    this.setState({
      camref: value,
    });
    this.props.link.setCamRef(value);
  }

  public onAdRefChange(event) {
    const { value } = event.target;
    this.setState({
      adRef: value,
    });
    this.props.link.setAdRef(value);
  }

  public onCreativerefChange(event) {
    const { value } = event.target;
    this.setState({
      creativeRef: value,
    });
    this.props.link.setCreativeref(value);
  }

  public onPubRefChange(event) {
    const { value } = event.target;
    this.setState({
      pubRef: value,
    });
    this.props.link.setPubRef(value);
  }

  public renderElement() {
    let element;
    if (this.state.trackingChannel === 'Commission Junction') {
      element = (
        <CjParameters
          onTrackingPIDSelectChange={this.handlePIDSelectChange}
          onSIDChange={this.handleSIDChange}
          selectedTrackingPID={this.state.pidValue}
          sidValue={this.state.sidValue}
        />
      );
    } else if (this.state.trackingChannel === 'PHG') {
      element = (
        <PhgParameters
          onCamRefChange={this.onCamRefChange}
          onAdRefChange={this.onAdRefChange}
          onCreativerefChange={this.onCreativerefChange}
          onPubRefChange={this.onPubRefChange}
          camref={this.state.camref}
          adRef={this.state.adRef}
          creativeRef={this.state.creativeRef}
          pubRef={this.state.pubRef}
        />
      );
    }

    return element;
  }

  public render() {
    return (
      <main className="container">
        <UitkLayoutFlex space="two">
          <>
            <UitkLayoutFlexItem minWidth="half_width">
              <UitkHeading tag="h1" size={5}>
                &nbsp;
              </UitkHeading>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem minWidth="half_width">
              <UitkLink align={UitkLinkAlign.RIGHT} iconPos={UitkLinkAlign.RIGHT}>
                <a
                  href="https://egaffiliates.zendesk.com/hc/en-us/articles/360035579333-Deeplink-Builder-Implementation-Guide"
                  target="_blank"
                >
                  Need Help?
                  <UitkIcon name="info_outline" />
                </a>
              </UitkLink>
            </UitkLayoutFlexItem>
          </>
        </UitkLayoutFlex>
        <LinkSettingsForm
          onLanguageSelectChange={this.handleLanguageSelectChange}
          selectedLanguage={this.state.language}
          onTrackingSelectChange={this.handleTrackingChannelSelectChange}
          selectedTrackingChannel={this.state.trackingChannel}
          renderElement={this.renderElement}
        />

        <UitkSpacing className="dlb-border-line">
          <div>
            <div className="dlb-link-settings-flex">
              <UitkHeading>Configure Deeplink</UitkHeading>
            </div>
            <Viewport>
              <ViewLarge>
                <>
                  <UitkSpacing margin="three">
                    <div>
                      <UitkTabs
                        selectedTab={this.state.selectedMainMenu}
                        onTabSelect={this.setSelectedMainMenu}
                        tabsType={UitkTabsType.EQUAL_WIDTH}
                      >
                        <UitkTab name="Hotels" subLabelText="">
                          <UitkSelect id="sub-page" label="Select the Page" onChange={this.handlePageMenuChange}>
                            {this.renderPageDropDown()}
                          </UitkSelect>
                        </UitkTab>
                        <UitkTab name="Flights" subLabelText="" />
                        <UitkTab name="Packages" subLabelText="" />
                        <UitkTab name="Cars" subLabelText="(coming soon)">
                          <ComingSoon />
                        </UitkTab>
                        <UitkTab name="Cruises" subLabelText="(coming soon)">
                          <ComingSoon />
                        </UitkTab>
                        <UitkTab name="Things to Do" subLabelText="(coming soon)">
                          <div className="uitk-grid all-y-margin-six">
                            <div className="uitk-cell all-y-gutter-ten">
                              <ComingSoon />
                            </div>
                          </div>
                        </UitkTab>
                      </UitkTabs>
                    </div>
                  </UitkSpacing>
                  <UitkSpacing padding="three">
                    <div>{this.state.lobForm}</div>
                  </UitkSpacing>
                </>
              </ViewLarge>
              <ViewSmall>
                <>
                  <UitkSpacing padding="three">
                    <div>
                      <UitkSelect id="main-menu" label="Select the Lob" onChange={this.setSelectedMainMenuDropDown}>
                        {this.renderLobDropDown()}
                      </UitkSelect>
                    </div>
                  </UitkSpacing>
                  {this.state.selectedMainMenu !== 'Flights' && this.state.selectedMainMenu !== 'Packages' ? (
                    <UitkSpacing padding="three">
                      <div>
                        <UitkSelect id="sub-page" label="Select the Page" onChange={this.handlePageMenuChange}>
                          {this.renderPageDropDown()}
                        </UitkSelect>
                      </div>
                    </UitkSpacing>
                  ) : (
                    ''
                  )}
                  <UitkSpacing padding="three">
                    <div>{this.state.lobForm}</div>
                  </UitkSpacing>
                </>
              </ViewSmall>
            </Viewport>
          </div>
        </UitkSpacing>
      </main>
    );
  }
}
